var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipAngle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 15.5C7.1186 18.7044 8.82462 19.5 11.9997 19.5C15.1747 19.5 16.8813 18.7044 16.5 15.5C15.31 5.5 8.96887 5.5 7.50002 15.5Z",
    fill: "#C9D2D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0235 17L18.2 18.0245L19.7755 18.9452C17.9553 20.7035 15.0375 21.6637 11.9986 21.6697C9.03482 21.6755 6.19021 20.7735 4.36455 19.084L5.85879 18.2108L2.03523 17.1863L1 21.05L2.57736 20.1283C4.8726 22.556 8.50496 23.6765 12.0025 23.6697C15.5689 23.6627 19.2705 22.4832 21.5539 19.9843L23.0587 20.8636L22.0235 17Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 5C13.1043 5 13.9998 4.10457 13.9998 3C13.9998 1.89543 13.1043 1 11.9998 1C10.8952 1 9.99976 1.89543 9.99976 3C9.99976 4.10457 10.8952 5 11.9998 5Z",
    fill: "#647B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5211 5.74234L9.27114 7.36734L8.47852 6.75763L9.72852 5.13263L10.5211 5.74234Z",
    fill: "#647B8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02114 8.99234L6.77114 10.6173L5.97852 10.0076L7.22852 8.38263L8.02114 8.99234Z",
    fill: "#647B8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52114 12.2423L4.27114 13.8673L3.47852 13.2576L4.72852 11.6326L5.52114 12.2423Z",
    fill: "#647B8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02114 15.4923L2.39614 16.3048L1.60352 15.6951L2.22852 14.8826L3.02114 15.4923Z",
    fill: "#647B8F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4784 5.74234L14.7284 7.36734L15.521 6.75763L14.271 5.13263L13.4784 5.74234Z",
    fill: "#647B8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9784 8.99234L17.2284 10.6173L18.021 10.0076L16.771 8.38263L15.9784 8.99234Z",
    fill: "#647B8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4784 12.2423L19.7284 13.8673L20.521 13.2576L19.271 11.6326L18.4784 12.2423Z",
    fill: "#647B8F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9784 15.4923L21.6034 16.3048L22.396 15.6951L21.771 14.8826L20.9784 15.4923Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipAngle);
export default __webpack_public_path__ + "static/media/TIP-angle.f2cb6f2e.svg";
export { ForwardRef as ReactComponent };